<div class="row quote-contract-list__header">
  <div class="col-sm-4">
    @if (tierList.length) {
      <p-select
        data-cy="quote-margin"
        [options]="tierList"
        [filter]="true"
        filterBy="label, value"
        [(ngModel)]="selectedTierName"
        [placeholder]="
          !selectedTier
            ? 'Margin: not applied'
            : 'Margin: ' + selectedTier.getName()
        "
        (onChange)="selectTier($event)"
        class="contract-tier-dropdown"
      >
      </p-select>
    }
  </div>
  <div class="col-sm-4"></div>
  <div class="col-sm-4">
    <app-search-box
      dataCy="rates-search"
      searchButtonDataCy="quote-icon-search"
      [(value)]="searchQuery"
      (searchSubmit)="onSearchQueryChange()"
    />
  </div>
</div>

<div class="row quote-contract-list__table">
  <div class="col-md-12">
    <app-table
      [columns]="columns()"
      [value]="rateList.items"
      [paginator]="rateList.totalItems > gridParams.limit"
      [loading]="loading"
      [rows]="gridParams.limit"
      [first]="gridParams.first"
      [totalRecords]="rateList.totalItems"
      (changePage)="loadPage($event.first / $event.rows + 1, $event.rows)"
      (sortRows)="sortGrid($event)"
      [(selection)]="selectedRates"
      (selectionChange)="onSelectionChange($event)"
      [selectable]="true"
    >
    </app-table>
  </div>
</div>
